"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICON_OPACITY = exports.ICON_COLOR = exports.ICON_KIND = exports.ICON_SEGMENT = exports.ICON_ID = void 0;
/* eslint-disable prettier/prettier */
// React
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = __importDefault(require("styled-components"));
// Enums
const enums_1 = require("./enums");
const next_utils_enums_icon_id_1 = require("@gerenciatd/next.utils.enums.icon-id");
const next_utils_enums_colors_1 = require("@gerenciatd/next.utils.enums.colors");
const next_utils_enums_segment_1 = require("@gerenciatd/next.utils.enums.segment");
// Utils
const utils_1 = require("./utils");
exports.ICON_ID = next_utils_enums_icon_id_1.ICON_ID;
exports.ICON_SEGMENT = next_utils_enums_segment_1.SEGMENT;
exports.ICON_KIND = enums_1.ICON_KIND;
exports.ICON_COLOR = next_utils_enums_colors_1.COLOR_DICTIONARY;
exports.ICON_OPACITY = next_utils_enums_colors_1.OPACITY;
const Span = (0, styled_components_1.default)(styled_components_1.default.span({})) `
  &::before {
    font-family: 'icon${props => props.col}';   
    content: '\\${props => props.iconId}' !important;
    color: ${props => props.colorOpacity};
    background-color: ${props => props.bgColorOpacity};
  }
`;
const Icon = (props) => {
    const { id, kind, className, color, opacity, collectionSource, segment, size, layoutSize, sizeCircular, backgroundColor, custoObjectInfo, } = props;
    if (!id) {
        return null;
    }
    const iconInfo = (0, utils_1.getIconInfo)(collectionSource, id, kind);
    if (!iconInfo) {
        return null;
    }
    const { collection, content } = iconInfo;
    if (!content || !collection) {
        return null;
    }
    const mySegment = (0, next_utils_enums_segment_1.getCssSegment)(segment);
    if (!mySegment) {
        return null;
    }
    const colorOpacity = (0, next_utils_enums_colors_1.getColor)(color, opacity, mySegment);
    const bgColorOpacity = (0, next_utils_enums_colors_1.getColor)(backgroundColor, opacity, mySegment);
    if (!colorOpacity || !bgColorOpacity) {
        return null;
    }
    const style = {
        fontSize: `${size / 16}rem`,
        height: `${layoutSize.h !== 'auto' ? `${layoutSize.h / 16}rem` : 'auto'}`,
        width: `${layoutSize.w !== 'auto' ? `${layoutSize.w / 16}rem` : 'auto'}`,
        minHeight: `${size / 16}rem`,
        minWidth: `${size / 16}rem`,
    };
    const cssCircular = `${sizeCircular > 0 ? ' icon-circular' : ''}`;
    if (cssCircular) {
        style.padding = `${sizeCircular / 16}rem`;
    }
    const ownClassName = `${className ? ` ${className}` : ''}`;
    let myClassName = `icon icon-n ${id}${cssCircular}${ownClassName}`;
    // Personalizacion
    let editModal = null;
    if (custoObjectInfo) {
        editModal = () => {
            custoObjectInfo.handler(custoObjectInfo.entryPoint);
        };
        myClassName = `${myClassName} custo-editable`;
    }
    return (react_1.default.createElement(Span, { className: myClassName, col: collection, iconId: content, style: style, colorOpacity: colorOpacity, bgColorOpacity: bgColorOpacity, onClick: editModal ? editModal : null }));
};
Icon.propTypes = {
    id: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(exports.ICON_ID))
    ]).isRequired,
    kind: prop_types_1.default.oneOf(Object.values(exports.ICON_KIND)),
    className: prop_types_1.default.string,
    color: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(exports.ICON_COLOR))
    ]),
    opacity: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(exports.ICON_OPACITY))
    ]),
    size: prop_types_1.default.number,
    collectionSource: prop_types_1.default.number,
    layoutSize: prop_types_1.default.shape({
        w: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
        h: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    }),
    sizeCircular: prop_types_1.default.number,
    backgroundColor: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(exports.ICON_COLOR))
    ]),
    segment: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(exports.ICON_SEGMENT))
    ]),
    custoObjectInfo: prop_types_1.default.shape({
        componentId: prop_types_1.default.string,
        componentInstance: prop_types_1.default.string,
        editFunction: prop_types_1.default.func,
    }),
};
Icon.defaultProps = {
    kind: exports.ICON_KIND.MEDIUM,
    className: '',
    opacity: exports.ICON_OPACITY['100'],
    color: exports.ICON_COLOR.GREY,
    size: 16,
    collectionSource: 0,
    layoutSize: {
        h: 'auto',
        w: 'auto',
    },
    sizeCircular: 0,
    custoObjectInfo: null,
    backgroundColor: exports.ICON_COLOR.TRANSPARENT,
    segment: exports.ICON_SEGMENT.GP,
};
exports.default = Icon;
//# sourceMappingURL=index.js.map